import React from 'react'

import PropTypes from 'prop-types'
import classNames from 'classnames'
import isFunction from 'lodash/isFunction'

import InputElement from 'react-input-mask'

import FormControl from './FormControl'

export default class TextInput extends FormControl {
  static propTypes = {
    id: PropTypes.string.isRequired,
    type: PropTypes.string,
    name: PropTypes.string,
    extraClass: PropTypes.string,
    label: PropTypes.string,
    labelClass: PropTypes.string,
    placeholder: PropTypes.string,
    helpText: PropTypes.string,
    disabled: PropTypes.bool,
    mask: PropTypes.string,
    validationFuncs: PropTypes.array,
    initialValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    autocomplete: PropTypes.string,
    maxChars: PropTypes.number,
    onBlurExternal: PropTypes.func,
    inputWrapperClass: PropTypes.string,
    wrapperClass: PropTypes.string,
    min: PropTypes.number,
    helpTextClassName: PropTypes.string
  }

  static defaultProps = {
    disabled: false,
    type: 'text',
    validationFuncs: [],
    initialValue: '',
    extraClass: '',
    maxChars: 524288,
    autocomplete: 'on',
    inputWrapperClass: 'input-wrapper'
  }

  getValue() {
    return this.state.value
  }

  handleBlur = event => {
    this.validate()

    if (isFunction(this.props.onBlurExternal)) {
      this.props.onBlurExternal(event)
    }
  }

  render() {
    const {
      id,
      type,
      name,
      label,
      labelClass,
      placeholder,
      mask,
      disabled,
      extraClass,
      helpText,
      autocomplete,
      maxChars,
      inputWrapperClass,
      min,
      wrapperClass,
      helpTextClassName
    } = this.props

    const groupClass = classNames({
      'form-group': !this.props.isGroup ? this.props.isGroup : true,
      'has-danger': !this.state.isValid,
      [wrapperClass]: !!wrapperClass
    })

    const widgetClass = classNames({
      'form-control': true,
      [extraClass]: !!extraClass,
      'form-control-danger': !this.state.isValid
    })

    const labelClassName = classNames({
      [labelClass]: !!labelClass
    })

    return (
      <fieldset className={groupClass}>
        {label && (
          <label className={labelClassName} htmlFor={id}>
            {label}
          </label>
        )}
        <div className={inputWrapperClass}>
          {mask ? (
            <InputElement
              ref={id}
              type={type}
              className={widgetClass}
              id={id}
              placeholder={placeholder}
              disabled={disabled}
              onBlur={this.handleBlur}
              onChange={this.handleChange}
              value={this.state.value}
              mask={mask}
              autoComplete={autocomplete}
            />
          ) : (
            <input
              ref={id}
              type={type}
              name={name}
              className={widgetClass}
              id={id}
              placeholder={placeholder}
              disabled={disabled}
              onBlur={this.handleBlur}
              onKeyPress={this.props.onKeyPress}
              onChange={this.handleChange}
              value={this.state.value}
              autoComplete={autocomplete}
              min={typeof min === 'number' ? min : null}
              maxLength={maxChars}
            />
          )}
          {helpText && <small className={helpTextClassName ? this.props.helpTextClassName : 'text-muted'}>{helpText}</small>}
          {this.state.errorMessage && <small className="text-danger">{this.state.errorMessage}</small>}
        </div>
      </fieldset>
    )
  }
}



// WEBPACK FOOTER //
// src/components/UI/TextInput.jsx